import { useMediaQueryHelper } from 'app/RuangGTKHomepageV3/hooks/useMediaQueryHelper'
import { useTogglesStore } from 'stores/toggles'

/**
 * Controls whether the desktop responsive layout is active for /dokumen pages.
 *
 * Driven by the Toggle SDK key 'dokumen-desktop-view-enabled'.
 * - false (default): always renders mobile layout
 * - true: uses actual viewport — desktop layout activates at ≥768px
 */
export const useDocumentDesktopView = () => {
  const { isDesktop: isDesktopViewport } = useMediaQueryHelper()
  const isDokumenDesktopEnabled = useTogglesStore(
    (state) => state.toggles?.['dokumen-desktop-view-enabled']
  )

  const isDesktop = isDokumenDesktopEnabled === true && isDesktopViewport

  return { isDesktop }
}
